import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  standalone: false,
})
export class TextInputComponent implements OnInit {
  @Input() control: FormControl
  @Input() label: string
  @Input() required: boolean = false
  @Input() placeholder: string
  @Input() errorText: string
  @Input() mask: string
  @Input() isReadOnly?: boolean = false
  @Input() pattern?: string
  @Input() type?: string = 'text'
  @Input() min?: number
  @Input() max?: number
  @Input() step?: number
  @Input() describedBy?: string
  // Overrides the label-derived id — needed when several inputs share the same label.
  @Input() controlId?: string
  id: string

  ngOnInit() {
    this.id = this.controlId || LabelToId(this.label)
  }
}
